import {userService} from 'src/modules/user/UserService';

function shouldFilterSongs() {
  return process.env.FREE_SONG_FILTER && !userService.user.hasAccessHiddenCatalog;
}
function filterSongs(entry) {
  if (entry && entry.version_type && entry.version_type.includes('_DRAFT')) {
    return false;
  }
  else if (shouldFilterSongs() && entry.piece) {
    return entry.piece.catalog_type === 'FREE' || entry.piece.catalog_type === 'PREMIUM';
  }
  else {
    return true;
  }
}

export function SET_CURRENT_PAGE(state, currentPage) {
  state.currentPage = currentPage;
}

// Search, Sorts & Filters
export function SET_SEARCH_VALUE(state, searchValue) {
  state.searchValue = searchValue;
}

export function SET_SELECTED_SORT(state, option) {
  state.selectedSort = option;
}

export function SET_CATALOG_OPTIONS(state, options) {
  state.catalogOptions = options;
}

export function SET_SELECTED_FILTER(state, newFilter) {
  if (state.catalogOptions.filters && state.catalogOptions.filters.values) {
    state.catalogOptions.filters.values.forEach((filter) => {
      if (filter.key === newFilter.key) {
        filter.model = newFilter.model;
      }
    });
  }
}

export function RESET_SELECTED_FILTERS(state) {
  if (state.catalogOptions.filters && state.catalogOptions.filters.values) {
    state.catalogOptions.filters.values.forEach((filter) => {
      if (filter.type === 'boolean') {
        filter.model = false;
      } else {
        filter.model = [];
      }
    });
  }
}

export function SET_NEW_SONGS(state, songs) {
  state.newSongs = songs.filter(filterSongs);
}

export function SET_USER_PIECES(state, data) {
  data.fast_to_play = data.fast_to_play.filter(filterSongs);
  data.finished = data.finished.filter(filterSongs);
  data.in_progress = data.in_progress.filter(filterSongs);
  data.to_improve = data.to_improve.filter(filterSongs);

  state.userVersions = data;
}

export function SET_FILTERED_SONGS(state, paginatedSongs) {
  state.filteredSongs = paginatedSongs.data;
  state.currentPage = paginatedSongs.meta.current_page;
  state.pageQty = paginatedSongs.meta.last_page;
}
export function SET_FILTERED_SONGS_PARAMETERS(state, parameters) {
  state.lastFilteredSongsParameters = parameters;
}
export function SET_CURRENT_SEARCH_PROMISE_KEY(state, key) {
  state.currentSearchPromiseKey = key;
}
export function CLEAR_FILTERED_SONGS(state) {
  state.filteredSongs = null;
}

// Challenges
export function SET_CHALLENGES_DIFFICULTY_DATA(state, {difficulty, challenges}) {
  //completed_at at the emd of the list, then by score desc
  state.challenges['d' + difficulty] = challenges.page.data.filter(filterSongs).sort((a, b) => {
    if (a.completed_at && b.completed_at) {
      return new Date(b.completed_at) - new Date(a.completed_at);
    } else if (a.completed_at) {
      return 1; // a is completed, b is not, so a should come after b
    } else if (b.completed_at) {
      return -1; // b is completed, a is not, so b should come after a
    } else {
      return b.score - a.score; // both are not completed, sort by score desc
    }
  });
  console.log('Challenges for difficulty ' + difficulty + ':', state.challenges['d' + difficulty]);
  state.challenges.count = state.challenges['d' + difficulty].length; // challenges.challenges_count;
  state.challenges.completed_count = challenges.completed_challenges_count;
  state.maxPage = challenges.page.last_page;
}

export function CLEAR_CHALLENGE_DATA(state) {
  state.challenges = {
    d1: null,
    d2: null,
    d3: null,
    d4: null,
    completed_count: 0,
    count: 0,
  };
  state.maxPage = 1;
}
